var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-flex", [_vm._v(_vm._s(_vm.type))])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }